import { Type } from '@angular/core';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { StyleStateEnum } from '../enums/style-state.enum';
import { TextStyleDefaultsModel } from './text-style-defaults.model';
import { TextStyleFieldModel } from './text-style-field.model';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';

export class ImageStyleFieldModel extends TextStyleFieldModel {
    defaultStyleStateOptions: DropdownOptionModel[] = [
        { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ];
    showDoBorder: boolean;
    allowExpertMode?: boolean = true;

    constructor(
        property: string,
        isPrimary: boolean = true,
        defaults: TextStyleDefaultsModel,
        label?: string,
        showStyleState?: boolean,
        showAlignmentButtons: boolean = true,
        showFontSizeDropdown: boolean = true,
        styleType?: StyleTypesApiEnum,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        description?: string,
        defaultStyleStateOptions?: DropdownOptionModel[],
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[],
        showDoBorder?: boolean
    ) {
        super(
            property,
            isPrimary,
            defaults,
            label,
            showStyleState,
            showAlignmentButtons,
            showFontSizeDropdown,
            styleType,
            fieldComponent,
            description,
            false,
            true,
            defaultStyleStateOptions,
            changeDefaultStyleStateOptions
        );
        if (defaultStyleStateOptions?.length) {
            this.defaultStyleStateOptions = defaultStyleStateOptions;
        }
        this.showDoBorder = showDoBorder;
    }
}
